export function getLanguageSelector() {
    return window.YP_LANGUAGE;
}
